import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addEquipment,
  getAllEquipments,
  getAllEquipmentTypes,
  removeEquipment,
  updateEquipment,
} from "../../apis/partner";
import { useDispatch } from "react-redux";
import { addEquipmentsData } from "../../store/Partner/partnerDataSlice";

// export const useFetchAllEquipments = (partnerId) => {
//   return useQuery({
//     queryKey: ["equipments", partnerId],
//     queryFn: () => {
//       return getAllEquipments(partnerId);
//     },
//     enabled: !!partnerId,
//     onError: (error) => {
//       console.error("Error fetching equipments:", error.message);
//     },
//   });
// };

export const useFetchAllEquipments = (partnerId) => {
  
  return useQuery({
    queryKey: ["equipments",partnerId],
    queryFn: () => getAllEquipments(partnerId),
    enabled: !!partnerId, // Only fetch if partnerId exists
    staleTime: 0, // Ensure fresh data on every fetch
    cacheTime: 0, // Prevent caching to force re-fetch on navigation
  });
};

export const useAddEquipment = (navigate, useSelector) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: ({ partnerId, equipment }) =>
      addEquipment(partnerId, equipment),
    onSuccess: (newEquipment,variables) => {
      const { partnerId } = variables;

  queryClient.refetchQueries({queryKey:["equipments",partnerId]})

      // dispatch(addEquipmentsData(newEquipment));
      navigate("/dashboard/equipments", { replace: true });
    },
    onError: (error) => {
      console.error(error);
    },
  });
};

export const useUpdateEquipment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ partnerId, equipmentId, equipment }) => {
      console.log("----> ", partnerId, equipmentId, equipment);

      if (!partnerId || !equipmentId) {
        throw new Error("Partner ID and Equipment ID are required");
      }
      if (!equipment.equipment_type?.id) {
        throw new Error("Equipment type ID is required");
      }
      const payload = {
        partnerId,
        equipment_type: {
          id: equipment.equipment_type.id, // Match backend expectation
        },
        title: equipment.title, // Map to backend's title
        equipment_name: equipment.title, // Backend also sets equipment_name to title
        equipment_model: equipment.equipment_model || "",
        equipment_status: equipment.equipment_status || "active",
        description: equipment.description || "",
        verification_status: equipment.verification_status || "pending",
        verification_notes: equipment.verification_notes || null,
        droneMediaUrl: equipment.droneMediaUrl || "", // Match backend's direct use of droneMediaUrl
        media_type: equipment.media_type || "image", // Ensure media_type is included
      };
      console.log("Sending update equipment payload:", payload);
      return updateEquipment(equipmentId, payload);
    },
    onSuccess: (response) => {
      console.log("Update equipment response:", response);
      const updatedEquipment = response; // Adjust based on backend response structure
      queryClient.setQueryData(
        ["equipments", updatedEquipment.partner_id],
        (oldData) => {
          if (oldData) {
            const newData = oldData.map((equipment) =>
              equipment.equipment_id === parseInt(updatedEquipment.equipment_id)
                ? {
                    ...updatedEquipment,
                    equipment_type: equipment.equipment_type, // Preserve equipment_type
                  }
                : equipment
            );
            return newData;
          }
          return [updatedEquipment];
        }
      );
      queryClient.invalidateQueries([
        "equipments",
        updatedEquipment.partner_id,
      ]);
    },
    onError: (error) => {
      console.error(
        "Error updating equipment:",
        error.message,
        error.response?.data
      );
      throw error; // Pass error to component for handling
    },
  });
};

export const useDeleteEquipment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ partnerId, equipmentId }) => {
      if (!partnerId || !equipmentId)
        throw new Error("Partner ID and Equipment ID are required");
      return removeEquipment(partnerId, equipmentId);
    },
    onSuccess: (deletedEquipment,variables) => {
        const { partnerId } = variables;
      queryClient.setQueryData(["equipments",partnerId], (oldData) => {
        
        if (oldData) {
          const newData = oldData.filter(
            (equipment) => equipment.equipment_id !== parseInt(deletedEquipment)
          );
          return newData;
        }
        return oldData;
      });
      queryClient.invalidateQueries(["equipments", partnerId]);
    },
    onError: (error) => {
      console.error("Error deleting equipment:", error.message);
    },
  });
};

export const useFetchAllEquipmentTypes = () => {
  return useQuery({
    queryKey: ["equipment-type"],
    queryFn: () => getAllEquipmentTypes(),
    onError: (error) => {
      console.error("Error fetching equipment types:", error.message);
    },
  });
};
